import styled from 'styled-components'

import { FileStyled } from '@ui/blocks/File/styles/FileStyled'

interface IUploadFileStyled {}

export const UploadFileStyled = styled.div<IUploadFileStyled>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
